import React, { useState } from 'react';
import './BeforeAfterSlider.css';

export default function BeforeAfterSlider({
  before,
  after,
  beforeAlt,
  afterAlt,
  label,
  className = '',
  loading = 'lazy'
}) {
  const [position, setPosition] = useState(50);

  return (
    <div
      className={`before-after-slider ${className}`.trim()}
      style={{ '--before-after-position': `${position}%` }}
    >
      <div className="before-after-slider__image before-after-slider__after">
        <img src={after} alt={afterAlt} loading={loading} />
      </div>
      <div className="before-after-slider__image before-after-slider__before">
        <img src={before} alt={beforeAlt} loading={loading} />
      </div>

      <span className="before-after-slider__label before-after-slider__label--before">Before</span>
      <span className="before-after-slider__label before-after-slider__label--after">After</span>

      <input
        className="before-after-slider__range"
        type="range"
        min="0"
        max="100"
        value={position}
        aria-label={`Compare before and after${label ? `: ${label}` : ''}`}
        aria-valuetext={`${position}% before image shown`}
        onChange={(event) => setPosition(Number(event.target.value))}
      />
      <div className="before-after-slider__divider" aria-hidden="true">
        <span className="before-after-slider__handle">↔</span>
      </div>
    </div>
  );
}
